/**
 * @generated SignedSource<<49a8b04fc3798cc5e42bb64eb7cfe233>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardContainer_issueNavigator_issueResults$data = {
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
  } | null | undefined> | null | undefined;
  readonly isCappingIssueSearchResult: boolean | null | undefined;
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentType": "cardContainer_issueNavigator_issueResults";
};
export type cardContainer_issueNavigator_issueResults$key = {
  readonly " $data"?: cardContainer_issueNavigator_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardContainer_issueNavigator_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cardContainer_issueNavigator_issueResults",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    },
    {
      "kind": "ScalarField",
      "name": "isCappingIssueSearchResult"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "a51c85a8ee17bb574907b5cd760bad2f";

export default node;
